// Browser-side calls for the file sandbox: read an uploaded file and turn it
// into a sandbox doc (or just extract its text for chat).

export const SANDBOX_EXT = /\.(docx|pptx|xlsx|xlsm|csv|tsv|pdf|md|markdown|txt)$/i;
export const SANDBOX_ACCEPT = ".docx,.pptx,.xlsx,.xlsm,.csv,.tsv,.pdf,.md,.txt";
export const SANDBOX_MAX_MB = 15;

export function canOpenInSandbox(name) { return SANDBOX_EXT.test(String(name || "")); }

export function readFileBase64(file) {
  return new Promise((resolve, reject) => {
    const r = new FileReader();
    r.onload = () => resolve(String(r.result || "").replace(/^data:[^,]*,/, ""));
    r.onerror = () => reject(r.error || new Error("Couldn't read the file"));
    r.readAsDataURL(file);
  });
}

async function postFile(path, file, token) {
  if (!canOpenInSandbox(file.name)) throw new Error("Open Word (.docx), PDF, Excel (.xlsx/.csv), PowerPoint (.pptx), Markdown or text files");
  if (file.size > SANDBOX_MAX_MB * 1024 * 1024) throw new Error(`Files up to ${SANDBOX_MAX_MB} MB can be opened`);
  const data = await readFileBase64(file);
  const r = await fetch(path, { method: "POST", headers: { Authorization: "Bearer " + token, "Content-Type": "application/json" }, body: JSON.stringify({ filename: file.name, data }) });
  const d = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(d.error || "Couldn't open that file");
  return d;
}

// → the new sandbox doc ({ id, kind, title, ... })
export async function importToSandbox(file, token) { return (await postFile("/api/live-docs/import", file, token)).doc; }
// → { kind, title, text, notes } — the file's contents for the chat model
export async function extractForChat(file, token) { return postFile("/api/documents/extract", file, token); }
